export const totalCosts = (serviceFee: number, fee: number, tax: number) => {
  return serviceFee + fee + tax;
};
